export enum LeadStatus {
    SENT = "sent",
    PENDING = "pending",
    REJECTED = "rejected"
}
export enum LeadStatus {
    SENT = "sent",
    PENDING = "pending",
    REJECTED = "rejected"
}
